<template>
    <section class="charts">
      <highcharts class="chart" :options="areaOptions" ref="areaCharts"></highcharts>
    </section>
</template>
<script>
//import VueHighcharts from '../../src/VueHighcharts.vue'
import * as data from '../assets/js/chartdata'
export default {
  components: {
   // VueHighcharts,
  },
  data() {
    return {
      areaOptions: {
          colors: ['#03a9f4', '#3f51b5', '#89A54E', '#80699B', '#3D96AE', '#DB843D', '#92A8CD', '#A47D7C', '#B5CA92'],    
          chart: {
              type: 'area'
          },
          title: {
              text: ''
          },
          subtitle: {
              text: ''
          },
          xAxis: {
              //allowDecimals: false,
              type: 'datetime',
              /*
              labels: {
                  formatter: function () {
                      return this.value; // clean, unformatted number for year
                  }
              }*/
          },
          yAxis: {
              title: {
                  text: '℃'
              },
              /*
              labels: {
                  formatter: function () {
                      return this.value / 1000 + '';
                  }
              }*/
          },
          credits: {
              enabled: false
          },
          tooltip: {
            // pointFormat: '{series.name} produced <b>{point.y:,.0f}</b><br/>warheads in {point.x}'
          },
          plotOptions: {
              area: {
                  pointStart: 10,
                  marker: {
                      enabled: false,
                      symbol: 'circle',
                      radius: 2,
                      states: {
                          hover: {
                              enabled: true
                          }
                      }
                  }
              }
          },
          series: [{
              name: 'Set Point',
              data: []
          }, {
              name: 'Present Value',
              data: []
          }]
      },
      chartDataInterval: ''
    }
  },
  created () {    
    //this.getChartData()
    this.randomChart()
  },
  beforeDestroy () {
    clearInterval(this.chartDataInterval)
  },
  methods: {
    randomRange(n1, n2) {
      return Math.floor( (Math.random() * (n2 - n1 + 1)) + n1 )
    },
    getChartData () {
        this.chartDataInterval = setInterval(() => {
          this.axios.get(`mod_getRealtime.php`)
            .then((result) => {
                let chart = this.$refs.areaCharts.chart
                let shift = chart.series[0].data.length > 30
                let setData = parseFloat(result.data[0].setPoint)
                let preData = parseFloat(result.data[0].preValue)
                let today = new Date()
                today.setHours(today.getHours() + 9)
                let time = today.getTime()
                let sPoint = [time, setData]
                let pPoint = [time, preData]
                chart.series[0].addPoint(sPoint, false, shift)
                chart.series[1].addPoint(pPoint, false, shift)
                chart.redraw()
//                console.log(result.data)
            }).catch((error) => {
                //alert('Error Detected. Entering Simulatation Mode');
               // this.randomChart()
            })
          }, 1000)
    },
    randomChart () {
      this.chartDataInterval = setInterval(() => {
        let chart = this.$refs.areaCharts.chart
        let shift = chart.series[0].data.length > 30        
        //console.log(chart)
        let setData = this.randomRange(22,26)
        let preData = this.randomRange(10,32)
        let today = new Date()
        today.setHours(today.getHours() + 9)
        let time = today.getTime()
        let sPoint = [time, setData]
        let pPoint = [time, preData]
        chart.series[0].addPoint(sPoint, false, shift)
        chart.series[1].addPoint(pPoint, false, shift)
        chart.redraw()
        
      }, 1000)
    }
  }
}
</script>